import React, { useMemo, useEffect, useState } from 'react';

import { Box } from '@material-ui/core';

import { Rotate } from '../../components/Rotate/Rotate';

export const DocumentoViewer = React.memo(({ file, height = '100%', width = '100%', withRotate = false }) => {
    const [rotation, setRotation] = useState(0);

    const handleRotate = (newRotation) => {
        setRotation(newRotation);
    }

    const fileUrl = useMemo(() => {
        if (!file) return null;
        return URL.createObjectURL(file);
    }, [file]);

    useEffect(() => {
        return () => {
            if (fileUrl) {
                URL.revokeObjectURL(fileUrl);
            }
        };
    }, [fileUrl]);

    if (!file) return null;

    const isPdf = file?.type === 'application/pdf';

    return (
        <Box style={{ width, height }}>
            {isPdf ? (
                <iframe
                    src={fileUrl}
                    title={file.name}
                    width="100%"
                    height="100%"
                    style={{
                        border: '1px solid #ccc',
                        borderRadius: 8
                    }}
                />
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
                    {withRotate &&
                        <div style={{ alignContent: 'top', marginBottom: '16px' }}>
                            <Rotate handleRotate={handleRotate} />
                        </div>
                    }
                    <img 
                        alt="Preview" 
                        src={fileUrl}
                        style={{ 
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                            transition: 'transform 0.3s', 
                            marginTop: rotation % 180 !== 0 ? '10%' : 'auto',
                            transform: `rotate(${rotation}deg)` 
                        }}
                    />
                </div>
            )}
        </Box>
    );
});

export default DocumentoViewer;